import { createContext, FC, ReactNode, useState } from "react";

export type ScrollContextType = {
	scrollingContainer: HTMLElement | null;
	setScrollingContainer: (scrollingContainer: HTMLElement | null) => void;
}

type Props = {
	children: ReactNode;
};

export const ScrollContext = createContext<ScrollContextType | null>(null);

export const ScrollProvider: FC<Props> = ({ children }) => {
	const [scrollingContainer, setScrollingContainer] = useState<HTMLElement | null>(null);

	return (
		<ScrollContext.Provider
			value={{
				scrollingContainer: scrollingContainer,
				setScrollingContainer: setScrollingContainer,
			}}
		>
			{children}
		</ScrollContext.Provider>
	);
}
